import React,  {useEffect} from 'react';
import MetaTags from 'react-meta-tags';
import { Col, Container, Row } from "reactstrap"
import {withRouter, useParams} from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader";

// Import Components
import LeftSidebar from './components/LeftSidebar';
import LeadTab from './components/LeadTab';

//redux
import {connect, useDispatch,useSelector} from "react-redux";


//actions
import {  leadsFilter} from "../../store/leads/actions";


const LeadsDetail = (props) => {

    const dispatch = useDispatch();
    const param = useParams();
    const str = param.id; 
    const leadsId = Number(str);


    useEffect(() => {
        
     dispatch(leadsFilter(`${leadsId}/`))
              
    },[dispatch, leadsId]);

    const lead = useSelector(state=>state.Leads.leads) 
    
    return ( 
        <React.Fragment>
        <div className="page-content">
            <MetaTags>
                <title>tccontrol| Perfil del Pre-Contacto</title>
            </MetaTags>
            <Container fluid>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="tccontrol" breadcrumbItem="Perfil del Pre-Contacto" />
                {props.loading ? (
                <Loader />
      ) : (

                <Row className="mb-4">
                    <Col>
                        
                        <LeftSidebar lead = {lead} />
                    </Col>
                    
                    <Col lg={12} className="justify-content-center">
  
                        <LeadTab lead ={lead} />
                       
                    </Col>
                </Row>
            )}
            </Container>
        </div>
    </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
    const { error, loading, leads } = state.Leads;
    return { error, loading, leads };
  };
  
export default withRouter(connect(mapStateToProps)(LeadsDetail));